(function() {
  if (window.__teaserRegularInit) return;
  window.__teaserRegularInit = true;

  document.addEventListener('click', function(e) {
    // Toggle menu
    var toggleBtn = e.target.closest('[data-teaser-toggle]');
    if (toggleBtn) {
      var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!expanded));
      var teaser = toggleBtn.closest('.teaser') || toggleBtn.closest('.teaser-comp');
      if (teaser) {
        teaser.classList.toggle('teaser--menu-active', !expanded);
      }
      toggleBtn.classList.toggle('teaser__icon-btn--active', !expanded);
      return;
    }

    var teaserSurface = e.target.closest('.teaser--cta-multiple-cta');
    if (teaserSurface && !e.target.closest('a, button, [data-teaser-video-ctrl]')) {
      var surfaceToggle = teaserSurface.querySelector('[data-teaser-toggle]');
      if (surfaceToggle) {
        var surfaceExpanded = surfaceToggle.getAttribute('aria-expanded') === 'true';
        surfaceToggle.setAttribute('aria-expanded', String(!surfaceExpanded));
        surfaceToggle.classList.toggle('teaser__icon-btn--active', !surfaceExpanded);
        teaserSurface.classList.toggle('teaser--menu-active', !surfaceExpanded);
      }
      return;
    }

    // Play/Pause
    var playBtn = e.target.closest('[data-teaser-play]');
    if (playBtn) {
      var ctrl = playBtn.closest('[data-teaser-video-ctrl]');
      var teaser = playBtn.closest('.teaser');
      var videos = teaser ? teaser.querySelectorAll('video') : [];
      videos.forEach(function(v) {
        if (v.paused) { v.play(); ctrl && ctrl.setAttribute('data-playing', ''); }
        else { v.pause(); ctrl && ctrl.removeAttribute('data-playing'); }
      });
      return;
    }

    // Sound
    var soundBtn = e.target.closest('[data-teaser-sound]');
    if (soundBtn) {
      var teaser = soundBtn.closest('.teaser');
      var videos = teaser ? teaser.querySelectorAll('video') : [];
      videos.forEach(function(v) { v.muted = !v.muted; });
      soundBtn.classList.toggle('teaser__sound-btn--muted');
      return;
    }
  });

  // Set initial playing state for videos
  document.querySelectorAll('[data-teaser-video-ctrl]').forEach(function(ctrl) {
    var teaser = ctrl.closest('.teaser');
    var videos = teaser ? teaser.querySelectorAll('video') : [];
    if (videos.length > 0) ctrl.setAttribute('data-playing', '');
  });
})();
